import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { isMobile } from 'react-device-detect'
import LoginTab from './components/Login'
import SignupTab from './components/Signup'
import BetaFilledTab from './components/BetaFilled'
import { setShowLoginPopup, setShowSignupPopup } from 'redux-thunk/redux/slices/gameSetting.slice'
import { BrandLogoIcon, BetaSignup } from 'components/ui-kit/Icons/svg/index'
import CommonPopup from 'components/ui-kit/CommonPopup/index'
import './login.scss'
import { loginImg, betaSignupImg } from 'components/ui-kit/Icons/png/index'

const Login = ({ showSignupPopup, setShowVerifyEmailPopup, setShowBetaThankYouPopup }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { showSignupPopup: showSignupPopupFromStore } = useSelector((state) => state.gameSetting)
  const isSignupTab = Boolean(showSignupPopup ?? showSignupPopupFromStore)
  const [registerTabActive, setRegisterTabActive] = useState(isSignupTab)
  const { signupLimit } = useSelector(state => state.user)

  useEffect(() => {
    setRegisterTabActive(isSignupTab)
  }, [isSignupTab])

  const betaFilledTab = registerTabActive && signupLimit

  const modalCloseHandler = () => {
    dispatch(setShowLoginPopup(false))
    dispatch(setShowSignupPopup(false))
  }

  const activateLoginTab = () => {
    setRegisterTabActive(false)
    dispatch(setShowSignupPopup(false))
    dispatch(setShowLoginPopup(true))
  }

  const activateRegisterTab = () => {
    setRegisterTabActive(true)
    dispatch(setShowLoginPopup(false))
    dispatch(setShowSignupPopup(true))
  }

  const getImage = () => {
    if (betaFilledTab) {
      return betaSignupImg
    }

    return loginImg
  }

  const renderLogo = () => {
    if (isMobile && betaFilledTab) {
      return <BetaSignup />
    }
    return <BrandLogoIcon />
  }

  // useEffect(() => {
  //   const initSeal = () => {
  //     if (
  //       window.anj_f6119bb2_07b1_422d_9d1a_40202a8999fb
  //     ) {
  //       window.anj_f6119bb2_07b1_422d_9d1a_40202a8999fb.init()
  //     } else {
  //       setTimeout(initSeal, 500)
  //     }
  //   }

  //   initSeal()
  // }, [])

  return (
    <CommonPopup
      modalCloseHandler={modalCloseHandler}
      id='login_modal'
      modalBodyClasses='overflow-x-hidden lg:!p-0'
      modalDialogClass='max-w-[800px] overflow-y-auto max-sm:max-w-none'
      modalContentClass='max-sm:h-full'
    >
      <div className='flex'>
        <div className='w-full max-sm:p-0 min-[992px]:w-5/12 px-4'>
          <div className='lg:rounded-l-4'>
            <div className='max-sm:pb-4 max-sm:pt-3'>
              <div
                className={`flex justify-between items-center mt-4 [&_img]:w-[100px] ${
                  isMobile && betaFilledTab
                    ? '[&_svg]:h-[97px] [&_svg]:w-full'
                    : '[&_svg]:mx-auto [&_svg]:mb-8 [&_svg]:mt-2 [&_svg]:h-12 [&_svg]:w-[238px] max-sm:[&_svg]:mb-4 max-sm:[&_svg]:mt-1 max-sm:[&_svg]:h-9 max-sm:[&_svg]:w-[178px]'
                }`}
              >
                {/* {renderLogo()} */}
                <img src='/assets/images/logo.png' alt='login_logo' />
                {/* <div className='mt-3 h-10 w-10 text-center'>
                  <div
                    id='anj-f6119bb2-07b1-422d-9d1a-40202a8999fb'
                    data-anj-seal-id='f6119bb2-07b1-422d-9d1a-40202a8999fb'
                    data-anj-image-size='128'
                    data-anj-image-type='basic-small'
                  />
                </div> */}
              </div>
              <div>
                <ul className='mb-0 flex list-none gap-3 p-0 sm:mb-4' role='tablist'>
                  <li className='flex-1' role='presentation'>
                    <button
                      className={`w-full max-h-10 cursor-pointer rounded-[0.625rem] border-2 border-solid px-[1.625rem] pb-1 pt-[0.3125rem] text-sm font-medium uppercase leading-7 max-sm:leading-6 ${
                        !registerTabActive
                          ? 'border-gold-dark bg-gold-btn text-white'
                          : 'border-[#5E5E5E] bg-transparent text-[#5E5E5E] hover:border-gold-dark hover:bg-gold-btn hover:text-white'
                      }`}
                      type='button'
                      role='tab'
                      aria-selected={!registerTabActive}
                      onClick={activateLoginTab}
                    >
                      {t('login')}
                    </button>
                  </li>
                  <li className='flex-1' role='presentation'>
                    <button
                      className={`w-full max-h-10 cursor-pointer rounded-[0.625rem] border-2 border-solid px-[1.625rem] pb-1 pt-[0.3125rem] text-sm font-medium uppercase leading-7 max-sm:leading-6 ${
                        registerTabActive
                          ? 'border-gold-dark bg-gold-btn text-white'
                          : 'border-[#5E5E5E] bg-transparent text-[#5E5E5E] hover:border-gold-dark hover:bg-gold-btn hover:text-white'
                      }`}
                      type='button'
                      role='tab'
                      aria-selected={registerTabActive}
                      onClick={activateRegisterTab}
                    >
                      {t('register')}
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            <div>
              {!registerTabActive && (
                <LoginTab />
              )}
              {registerTabActive && (
                signupLimit
                  ? (
                    <BetaFilledTab
                      setShowBetaThankYouPopup={setShowBetaThankYouPopup}
                    />
                    )
                  : (
                    <SignupTab
                      setShowVerifyEmailPopup={setShowVerifyEmailPopup}
                    />
                    )
              )}
            </div>
          </div>
        </div>
        <div className='hidden w-full p-0 min-[992px]:block min-[992px]:w-7/12'>
          <div className='relative h-full overflow-hidden rounded-r-[15px] bg-login-banner bg-contain bg-no-repeat'>
            <div
              role='img'
              aria-label='auth'
              className={`absolute bottom-0 w-full bg-login-page bg-bottom bg-no-repeat [filter:drop-shadow(0_140px_50px_#FAD400)] ${
                betaFilledTab
                  ? 'inset-0 h-full bg-cover bg-center'
                  : 'h-full bg-contain'
              }`}
            />
            <div
              className={`absolute top-8 px-4 text-center [&_a]:pl-0.5 [&_a]:text-[var(--blue-300)] [&_p]:m-0 [&_p]:text-xs [&_p]:font-semibold [&_p]:leading-5 [&_p]:text-white ${
                betaFilledTab ? 'hidden' : ''
              }`}
            >
              <p>
                {t('usersConsent')}
                <NavLink to='#'>{t('termsOfService')}</NavLink>
              </p>
            </div>
          </div>
        </div>
      </div>
    </CommonPopup>
  )
}

export default Login
